import React, { useMemo, useState } from 'react';
import { DashboardHeader } from './components/DashboardHeader';
import { InputCard } from './components/InputCard';
import { MainMetrics } from './components/MainMetrics';
import { CriticalThresholds } from './components/CriticalThresholds';
import { DeliveryFunnel } from './components/DeliveryFunnel';
import { TrafficLight } from './components/TrafficLight';
import { CTAButton } from './components/CTAButton';
import { CountrySelector } from './components/CountrySelector';
import { calculateMetrics } from './utils/calculations';
import type { DashboardInputs, CountryCode } from './utils/calculations';
export function App() {
  const [country, setCountry] = useState<CountryCode>('CO');
  const [inputs, setInputs] = useState<DashboardInputs>({
    price: 74900,
    productCost: 10000,
    fleteInicial: 19000,
    cancelledPct: 10,
    returnPct: 25,
    cpaIdeal: 15000
  });
  const metrics = useMemo(() => calculateMetrics(inputs), [inputs]);
  const handleInputChange = (field: keyof DashboardInputs, value: number) => {
    setInputs(prev => ({
      ...prev,
      [field]: value
    }));
  };
  return <div className="min-h-screen bg-dark text-white selection:bg-salmon/30 selection:text-white font-sans overflow-x-hidden" data-id="element-0">
      <div className="fixed inset-0 pointer-events-none z-0" data-id="element-1">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-salmon/5 blur-[120px]" data-id="element-2"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-cyber-green/5 blur-[120px]" data-id="element-3"></div>
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAwIDEwIEwgNDAgMTAgTSAxMCAwIEwgMTAgNDAiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgyNTUsMjU1LDI1NSwwLjAyKSIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIi8+PC9zdmc+')] opacity-50" data-id="element-4"></div>
      </div>

      <main className="relative z-10 container mx-auto px-4 py-12 max-w-6xl" data-id="element-5">
        <DashboardHeader data-id="element-6" />

        {/* Country Selector */}
        <CountrySelector selected={country} onChange={setCountry} data-id="element-7" />

        {/* 3-Column Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-4 mb-6" data-id="element-8">
          <InputCard inputs={inputs} metrics={metrics} onChange={handleInputChange} country={country} data-id="element-9" />
          <MainMetrics metrics={metrics} country={country} data-id="element-10" />
          <CriticalThresholds metrics={metrics} country={country} data-id="element-11" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6" data-id="element-12">
          <DeliveryFunnel metrics={metrics} data-id="element-13" />
          <TrafficLight metrics={metrics} country={country} data-id="element-14" />
        </div>

        <CTAButton data-id="element-15" />
      </main>
    </div>;
}